import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TiersService } from '../services/tiers.service';
import { Tier } from '../../models/tier';

@Injectable()
export class TiersResolver implements Resolve<Tier[]>
{
	private tiersService: TiersService;

	constructor(tiersService: TiersService)
	{
		this.tiersService = tiersService;
	}

	resolve(): Promise<Tier[]>
	{
		return this.tiersService.getTiers();
	}
}



// WEBPACK FOOTER //
// ./src/app/tiers/resolvers/tiers.resolver.ts